import { apiEndpoint } from '@/config';
import { postRequest } from '@/lib/swr';
import {
  ApiErrorResponse,
  ApiSuccessResponse,
} from '@hidayahlab/academy-suite-corelib';
import useSWRMutation from 'swr/mutation';
import { useGetCustomer } from './use-customer-api';

type FacebookPixelEventName =
  | 'PageView'
  | 'ViewContent'
  | 'Search'
  | 'AddToCart'
  | 'AddToWishlist'
  | 'InitiateCheckout'
  | 'AddPaymentInfo'
  | 'Purchase'
  | 'Lead'
  | 'CompleteRegistration'
  | 'webinar_registration';

type FacebookPixelActionSource =
  | 'email'
  | 'website'
  | 'app'
  | 'phone_call'
  | 'chat'
  | 'physical_store'
  | 'system_generated'
  | 'other';

export type FacebookPixelEventType = {
  event_name: FacebookPixelEventName;
  event_id: string;
  user_data: Record<string, any>;
  custom_data?: Record<string, any>;
  action_source: FacebookPixelActionSource;
};
export function useFacebookPixelTrack() {
  const { customer } = useGetCustomer();

  const customerId = customer?.id;

  const res = useSWRMutation<
    ApiSuccessResponse<FacebookPixelEventType>,
    ApiErrorResponse,
    string,
    FacebookPixelEventType
  >(
    `${apiEndpoint}/facebook-pixel/track/${customerId}`,
    (url: string, { arg }) => postRequest(url, { arg }),
  );

  return {
    ...res,
    customer,
  };
}
